import { render, staticRenderFns } from "./WorkPacks.vue?vue&type=template&id=0519acf4&"
import script from "./WorkPacks.vue?vue&type=script&lang=js&"
export * from "./WorkPacks.vue?vue&type=script&lang=js&"
import style0 from "./WorkPacks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0519acf4')) {
      api.createRecord('0519acf4', component.options)
    } else {
      api.reload('0519acf4', component.options)
    }
    module.hot.accept("./WorkPacks.vue?vue&type=template&id=0519acf4&", function () {
      api.rerender('0519acf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/workPacks/components/WorkPacks.vue"
export default component.exports